<template lang="pug">
#v-quiz.quiz.container
  h2.quiz__title 測驗您的量測關鍵知識
  p.quiz__description 完整填寫資料與測驗，資料送出後即可獲 KEYSIGHT 毫米波量測白皮書，並參加抽獎，我們將會在活動結束後兩週內以簡訊與 email 通知中獎者，並將獎品寄出。（商品若有不同顏色則隨機選色寄出）
  .quiz__problem.quiz-problem
    p.quiz-problem__question 在射頻、微波、毫米波和信號完整性領域上常用以下那種參數來表徵一個元器件的特性?
    .quiz-problem__answers
      button.quiz-problem__answer(@click='pick(0, "A")', :class='{"quiz-problem__answer--incorrect": answer[0] === "A", "quiz-problem__answer--disabled": result[0] !== null && answer[0] !== "A"}') A-參數
      button.quiz-problem__answer(@click='pick(0, "B")', :class='{"quiz-problem__answer--correct": result[0] !== null}') S-參數
      button.quiz-problem__answer(@click='pick(0, "C")', :class='{"quiz-problem__answer--incorrect": answer[0] === "C", "quiz-problem__answer--disabled": result[0] !== null && answer[0] !== "C"}') E-參數
    transition(name='result')
      img.quiz-problem__result(v-if='result[0] === true', src='@/assets/correct.svg', alt='correct')
    transition(name='result'): img.quiz-problem__result(v-if='result[0] === false', src='@/assets/incorrect.svg', alt='incorrect')
  .quiz__problem.quiz-problem
    p.quiz-problem__question 請問近來興起之E-band應用 (例如汽車雷達、WiGig 802.11ad甚至將來的5G應用等) 是哪個頻段?
    .quiz-problem__answers
      button.quiz-problem__answer(@click='pick(1, "A")', :class='{"quiz-problem__answer--correct": result[1] !== null}') 60-90 GHz
      button.quiz-problem__answer(@click='pick(1, "B")', :class='{"quiz-problem__answer--incorrect": answer[1] === "B", "quiz-problem__answer--disabled": result[1] !== null && answer[1] !== "B"}') 10-50 MHz
      button.quiz-problem__answer(@click='pick(1, "C")', :class='{"quiz-problem__answer--incorrect": answer[1] === "C", "quiz-problem__answer--disabled": result[1] !== null && answer[1] !== "C"}') 1~1.5 THz
    transition(name='result'): img.quiz-problem__result(v-if='result[1] === true', src='@/assets/correct.svg', alt='correct')
    transition(name='result'): img.quiz-problem__result(v-if='result[1] === false', src='@/assets/incorrect.svg', alt='incorrect')
  .quiz__problem.quiz-problem
    p.quiz-problem__question 以下何者為向量網路分析儀(VNA)的常見用途?
    .quiz-problem__answers
      button.quiz-problem__answer(@click='pick(2, "A")', :class='{"quiz-problem__answer--incorrect": answer[2] === "A", "quiz-problem__answer--disabled": result[2] !== null && answer[2] !== "A"}') 元器件特性表徵
      button.quiz-problem__answer(@click='pick(2, "B")', :class='{"quiz-problem__answer--incorrect": answer[2] === "B", "quiz-problem__answer--disabled": result[2] !== null && answer[2] !== "B"}') 信號完整性驗證
      button.quiz-problem__answer(@click='pick(2, "C")', :class='{"quiz-problem__answer--correct": result[2] !== null}') 兩者皆是
    transition(name='result'): img.quiz-problem__result(v-if='result[2] === true', src='@/assets/correct.svg', alt='correct')
    transition(name='result'): img.quiz-problem__result(v-if='result[2] === false', src='@/assets/incorrect.svg', alt='incorrect')
</template>

<script>
export default {
  name: 'Quiz',
  data() {
    return {
      result: [null, null, null],
      answer: [null, null, null],
    }
  },
  methods: {
    pick(question, answer) {
      if(question === 0) { this.$set(this.result, question, answer === 'B') }
      else if(question === 1) { this.$set(this.result, question, answer === 'A') }
      else if(question === 2) { this.$set(this.result, question, answer === 'C') }
      this.$set(this.answer, question, answer)
    },
  },
}
</script>

<style lang="sass" scoped>
.result-enter-active
  transition: opacity .2s
.result-enter
  opacity: 0

.quiz
  padding-bottom: 60px
  padding-top: 60px
  &__title
    +font(32px, #E50029, 32px, 2.13px, 500)
    margin-bottom: 34px
    text-align: center
    &::after
      border-bottom: 2px solid #E50029
      content: ''
      display: block
      margin-left: auto
      margin-right: auto
      padding-bottom: 34px
      width: 80px
  &__description
    +font(20px, #5A5A5A, 32px, 1.5px)
    margin-bottom: 60px
  &__problem
    margin-bottom: 30px
.quiz-problem
  border: 6px solid #EBEBEB
  padding: 36px 60px
  position: relative
  &__question
    +font(24px, black, 42px, 2.76px)
    margin-bottom: 22px
  &__answer
    +font(20px, white, null, 2px)
    +size(190px, 54px)
    background-color: #868686
    margin-right: 24px
    transition: background-color .2s
    &:hover
      background-color: #5A5A5A
    &--incorrect
      background-color: #0C0C0C
      pointer-events: none
    &--correct
      background-color: #E50029
      pointer-events: none
    &--disabled
      background-color: #CBCBCB
      pointer-events: none
  &__result
    bottom: 36px
    position: absolute
    right: 36px
    width: 54px

@media (max-width: 991px)
  .quiz
    padding-bottom: 40px
    padding-top: 40px
    &__title
      +font(20px, null, 28px, 1px)
      margin-bottom: 20px
      &::after
        padding-bottom: 24px
        width: 55px
    &__description
      +font(14px, null, 24px, 1.04px)
      margin-bottom: 30px
      text-align: center
    &__problem
      margin-bottom: 20px
  .quiz-problem
    padding: 20px 14px
    text-align: center
    &__question
      +font(15px, null, 26px, 1.73px)
      margin-bottom: 20px
      text-align: left
    &__answers
      margin-bottom: -14px
    &__answer
      +font(15px, null, null, 1.5px)
      +size(170px, 40px)
      display: block
      margin-bottom: 14px
      margin-left: auto
      margin-right: auto
      &--incorrect
        background-color: #0C0C0C !important
      &--correct
        background-color: #E50029 !important
      &--disabled
        background-color: #CBCBCB !important
    &__result
      margin-top: 20px
      position: static
      width: 36px
</style>
